import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-spag-course',
    templateUrl: './spag-course.component.html',
    styleUrls: ['./spag-course.component.css'],
    standalone: false
})
export class SpagCourseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openExternalLink(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fcdae201654815f849f0ce15d194cd8d';
  }

  bookSlot():void{
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fcdae201654815f849f0ce15d194cd8d/book-a-slot';
  }

}
